import type { AuthUser } from '@/types/auth/authTypes';

type SessaoPortalClaims = Pick<AuthUser, 'tipoUsuario' | 'pessoaId' | 'portalScope'>;

const nasceuNoPortal = (user: SessaoPortalClaims): boolean =>
  user.portalScope === true || user.tipoUsuario === 'NOTIFICADO';

/**
 * Quem pode ABRIR o portal. Não é o mesmo que "nasceu no portal": a sessão plena
 * de quem entrou por e-mail + código já provou posse da conta, então recusá-la
 * aqui seria um gate mais duro que o do back — as rotas do portal pedem só
 * `authenticate`, e o escopo por `pessoaId` continua valendo para as duas.
 *
 * `pessoaId` é o requisito real: é por ele que o portal escopa tudo. Sem ele não
 * há o que mostrar, venha a sessão de onde vier.
 */
export const podeAbrirPortal = (user: SessaoPortalClaims): boolean => Boolean(user.pessoaId);

/**
 * Quem NÃO pode sair do portal por conta própria. Só a sessão que nasceu de um
 * magic link — a promoção (`POST /me/sessao/plataforma`) é a saída, e é ela que
 * troca o token antes de a navegação acontecer.
 */
export const deveConfinarAoPortal = (user: SessaoPortalClaims): boolean => nasceuNoPortal(user);
